import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const LiveMatchTracker = loadable(() => pMinDelay(import('./LiveMatchTracker'), 300), {
  fallback: <Loading />
});

const AsyncLiveMatchTracker = props => {
  const pageConfig = {
    headerType: 'mobile-none',
    footerType: 'none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation bg-solid-gray`
      },
      title: 'Bilyoner.com | Canlı Anlatım',
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <LiveMatchTracker { ...props }/>
    </ApplicationLayout>
  );
};

AsyncLiveMatchTracker.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncLiveMatchTracker;
